@if (submitToTimes) {
<div sxBorderWidth="1px 0 0" sxBorderColor="one" sxPadding="medium" sxBackground="light">
    <form [formGroup]="timeForm">

        <!-- Number of Rooms and Accommodation Charges in one row -->
        <div sxRow sxGap="10px" sxWidth="fill" sxMargin="0 0 10px 0">
            <div sxCol sxWidth="fill">
                <label sxMargin="0 0 4px 4px" sxColor="two" sxTextSize="small"
                    style="display: block; font-weight: 500;">No.
                    of Rooms</label>
                <input type="number" formControlName="numRooms" placeholder="Enter number of rooms"
                    [class.error]="isFieldInvalid('numRooms')"
                    style="width: 100%; padding: 10px 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; background: white;">
                @if (isFieldInvalid('numRooms')) {
                <div sxMargin="4px 0 0 4px" sxTextSize="small" sxColor="danger">
                    {{ getFieldError('numRooms') }}
                </div>
                }
            </div>
            <div sxCol sxWidth="fill">
                <label sxMargin="0 0 4px 4px" sxColor="two" sxTextSize="small"
                    style="display: block; font-weight: 500;">Charges</label>
                <input type="text" formControlName="accommodationCharges" placeholder="₹₹"
                    [class.error]="isFieldInvalid('accommodationCharges')"
                    style="width: 100%; padding: 10px 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; background: white;">
                @if (isFieldInvalid('accommodationCharges')) {
                <div sxMargin="4px 0 0 4px" sxTextSize="small" sxColor="danger">
                    {{ getFieldError('accommodationCharges') }}
                </div>
                }
            </div>
        </div>

        <!-- Purpose of Visit in its own row -->
        <div sxMargin="0 0 10px 0">
            <label sxMargin="0 0 4px 4px" sxColor="two" sxTextSize="small"
                style="display: block; font-weight: 500;">Purpose
                of Visit
            </label>
            <div style="position: relative;" sxColor="three">
                <select formControlName="purposeOfVisit" [class.error]="isFieldInvalid('purposeOfVisit')"
                    style="width: 100%; padding: 12px 12px 12px 10px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; background: white; appearance: none; cursor: pointer; transition: border-color 0.2s ease;">
                    <option value="">Select purpose of visit</option>
                    @for (option of timePurposeOfVisitOptions; track option) {
                    <option [value]="option">
                        {{ option }}
                    </option>
                    }
                </select>
                <ion-icon name="chevron-down-outline"
                    style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: #999; pointer-events: none; font-size: 16px;"></ion-icon>
            </div>
            @if (isFieldInvalid('purposeOfVisit')) {
            <div sxMargin="4px 0 0 4px" sxTextSize="small" sxColor="danger">
                {{ getFieldError('purposeOfVisit') }}
            </div>
            }
        </div>

        <div sxMargin="0 0 10px 0">
            <label sxMargin="0 0 4px 4px" sxColor="two" sxTextSize="small"
                style="display: block; font-weight: 500;">Country</label>
            <div style="position: relative;" sxColor="three">
                <select formControlName="country" [class.error]="isFieldInvalid('country')"
                    style="width: 100%; padding: 12px 12px 12px 10px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; background: white; appearance: none; cursor: pointer; transition: border-color 0.2s ease;">
                    <option value="">Select country</option>
                    @for (option of timeCountryOptions; track option) {
                    <option [value]="option">
                        {{ option }}
                    </option>
                    }
                </select>
                <ion-icon name="chevron-down-outline"
                    style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: #999; pointer-events: none; font-size: 16px;"></ion-icon>
            </div>
            @if (isFieldInvalid('country')) {
            <div sxMargin="4px 0 0 4px" sxTextSize="small" sxColor="danger">
                {{ getFieldError('country') }}
            </div>
            }
        </div>

        @if (shouldShowStateField) {
        <div sxMargin="0 0 10px 0">
            <label sxMargin="0 0 4px 4px" sxColor="two" sxTextSize="small"
                style="display: block; font-weight: 500;">State</label>
            <div style="position: relative;" sxColor="three">
                <select formControlName="state" [class.error]="isFieldInvalid('state')"
                    style="width: 100%; padding: 12px 12px 12px 10px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; background: white; appearance: none; cursor: pointer; transition: border-color 0.2s ease;">
                    <option value="">Select state</option>
                    @for (option of timeStateOptions; track option) {
                    <option [value]="option">
                        {{ option }}
                    </option>
                    }
                </select>
                <ion-icon name="chevron-down-outline"
                    style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: #999; pointer-events: none; font-size: 16px;"></ion-icon>
            </div>
            @if (isFieldInvalid('state')) {
            <div sxMargin="4px 0 0 4px" sxTextSize="small" sxColor="danger">
                {{ getFieldError('state') }}
            </div>
            }
        </div>
        }


    </form>

    <!-- Time Stats Table -->
    @if (timeStats) {
    <div sxMargin="20px 0 20px 0">

        <div sxOverflow="auto" sxRadius="small" sxBorderWidth="1px" sxBorderColor="one">

            <table style="width: 100%; border-collapse: collapse;">

                <tbody>
                    <!-- Age Section -->
                    <tr style="background-color: #f8f9fa; border-bottom: 1px solid #e0e0e0;">
                        <td colspan="2" style="padding: 8px 12px; font-size: 13px; font-weight: 600; color: #333;">
                            <ion-icon name="calendar-outline"
                                style="margin-right: 6px; vertical-align: middle;"></ion-icon>Age Groups
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td style="padding: 8px 12px 8px 24px; font-size: 13px; color: #666;">
                            <ion-icon name="person-outline"
                                style="margin-right: 6px; vertical-align: middle; color: #4CAF50;"></ion-icon>Up
                            to 20 years
                        </td>
                        <td style="text-align: right; padding: 8px 2px 8px 12px;">
                            <plus-minus [(value)]="timeStats.guestUpto20" [min]="0"></plus-minus>
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td style="padding: 8px 12px 8px 24px; font-size: 13px; color: #666;">
                            <ion-icon name="person-outline"
                                style="margin-right: 6px; vertical-align: middle; color: #2196F3;"></ion-icon>21-40
                            years
                        </td>
                        <td style="text-align: right; padding: 8px 2px 8px 12px;">
                            <plus-minus [(value)]="timeStats.guest21To40" [min]="0"></plus-minus>
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td style="padding: 8px 12px 8px 24px; font-size: 13px; color: #666;">
                            <ion-icon name="person-outline"
                                style="margin-right: 6px; vertical-align: middle; color: #FF9800;"></ion-icon>41-60
                            years
                        </td>
                        <td style="text-align: right; padding: 8px 2px 8px 12px;">
                            <plus-minus [(value)]="timeStats.guest41To60" [min]="0"></plus-minus>
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td style="padding: 8px 12px 8px 24px; font-size: 13px; color: #666;">
                            <ion-icon name="person-outline"
                                style="margin-right: 6px; vertical-align: middle; color: #9C27B0;"></ion-icon>Above
                            61 years
                        </td>
                        <td style="text-align: right; padding: 8px 2px 8px 12px;">
                            <plus-minus [(value)]="timeStats.guestAbove61" [min]="0"></plus-minus>
                        </td>
                    </tr>

                    <!-- Gender Section -->
                    <tr style="background-color: #f8f9fa; border-bottom: 1px solid #e0e0e0;">
                        <td colspan="2" style="padding: 8px 12px; font-size: 13px; font-weight: 600; color: #333;">
                            <ion-icon name="people-outline"
                                style="margin-right: 6px; vertical-align: middle;"></ion-icon>Gender
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td style="padding: 8px 12px 8px 24px; font-size: 13px; color: #666;">
                            <ion-icon name="male-outline"
                                style="margin-right: 6px; vertical-align: middle; color: #2196F3;"></ion-icon>Male
                        </td>
                        <td style="text-align: right; padding: 8px 2px 8px 12px;">
                            <plus-minus [(value)]="timeStats.maleGuests" [min]="0"></plus-minus>
                        </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td style="padding: 8px 12px 8px 24px; font-size: 13px; color: #666;">
                            <ion-icon name="female-outline"
                                style="margin-right: 6px; vertical-align: middle; color: #E91E63;"></ion-icon>Female
                        </td>
                        <td style="text-align: right; padding: 8px 2px 8px 12px;">
                            <plus-minus [(value)]="timeStats.femaleGuests" [min]="0"></plus-minus>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>

        <!-- Warning when totals don't match -->
        @if (!totalsMatch) {
        <div sxMargin="10px 0 0 0" sxPadding="10px" sxRadius="small" sxBorderWidth="1px" sxBorderColor="warning"
            sxBackgroundColor="warning-light">
            <div sxRow sxAlign="start" sxGap="8px">
                <ion-icon name="warning-outline" sxColor="warning" style="font-size: 18px; margin-top: 2px;"></ion-icon>
                <div sxCol sxGap="2px">
                    <p sxMargin="0" sxTextSize="small" sxTextWeight="bold" sxColor="warning">Data Mismatch
                        Warning</p>
                    <p sxMargin="0" sxTextSize="small" sxColor="warning">
                        The total of age groups ({{ (timeStats?.guestUpto20 || 0) + (timeStats?.guest21To40
                        || 0) + (timeStats?.guest41To60 || 0) + (timeStats?.guestAbove61 || 0) }})
                        does not match the total of gender groups ({{ (timeStats?.maleGuests || 0) +
                        (timeStats?.femaleGuests || 0) }}).
                    </p>
                </div>
            </div>
        </div>
        }
    </div>
    }

</div>
}